import {Customer} from '../dto/customer';
import {AddressUploadDto} from '../dto/address-upload';

export class CustomerChangeAddressStatusModel {
  public isSuccess: boolean;
  public customer: Customer;
  public files: AddressUploadDto[];
  public failReasonCode: string;
}
